// External libraries
import styled from '@emotion/styled';
import { TEXT_COLOR } from '@/styles';

const AccountFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const AddressLoadingContainer = styled.div`
  margin-bottom: 16px;

  @media (min-width: 365px) {
    margin-bottom: 18px;
  }

  > div:not(:last-child) {
    margin-bottom: 12px;
  }
`;

const Section = styled.section`
  margin-bottom: 16px;
`;

const SignupValueProp = styled.p`
  font-size: 15px;
  font-weight: normal;
  line-height: 1.6;
  margin-bottom: 18px;
`;

const SignupValuePropBold = styled(SignupValueProp)`
  font-weight: bold;
`;

const CobrandedDisclaimer = styled.p`
  color: ${TEXT_COLOR};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0 5px 16px;
`;

export {
  AccountFieldsContainer,
  AddressLoadingContainer,
  Section,
  SignupValueProp,
  SignupValuePropBold,
  CobrandedDisclaimer,
};
